import { PlayPanel } from "type/panel/Panel.type";

export type GridCoordinates = {
  columnStart: number;
  columnEnd: number;
  rowStart: number;
  rowEnd: number;
};

export type AreaSource = {
  type: string;
  fileName: string;
  content: string;
  duration: number;
};

export type PlayArea = {
  area: GridCoordinates;
  source: AreaSource[];
  start: number;
};

export type Panel = {
  datum: Date;
  title: string;
  slug: string;
  areas: PlayArea[];
};

export const playAreaTotalSeconds = (playArea: PlayArea): number => {
  let res = playArea.source.reduce(
    (previousValue: number, areaSource: AreaSource) =>
      previousValue + areaSource.duration,
    0
  );
  if (playArea.start) {
    res = res + playArea.start;
  }

  return res;
};

export const playPanelTotalSeconds = (panel: Panel): number => {
  let res = panel.areas.reduce((previousValue: number, area: PlayArea) => {
    const totalAreaSec = playAreaTotalSeconds(area);
    return totalAreaSec > previousValue ? totalAreaSec : previousValue;
  }, 0);

  return res;
};

export const playAreaIdGet = (playMapInd: number, areaInd: number): string => {
  return `play_area_${playMapInd}_${areaInd}`;
};

export const elDimensionsGetById = (elId: string): any => {
  const el = document.getElementById(elId);
  const result = {
    offsetWidth: el?.offsetWidth,
    offsetHeight: el?.offsetHeight,
  };

  return result;
};
